import { apiFetch } from './client';

export const listGalleryImages = (token) => apiFetch(token, '/gallery');

export const createGalleryImage = (token, formData) =>
  apiFetch(token, '/gallery', { method: 'POST', body: formData });

export const deleteGalleryImage = (token, galleryId) =>
  apiFetch(token, `/gallery/${galleryId}`, { method: 'DELETE' });
